import React from 'react';
import Namsteji_Manikchand_Icon from '../../../../../assets/images/Namsteji_Manikchand_Icon.svg';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';

const ProductThumbnailsComponents: React.FC<any> = ({
  thumbnails,
  thumbIndex,
  setThumbIndex,
  setScrollDirection,
  setIsManualSelect,
  mainImage,
  setMainImage,
  SERVER_URL,
}) => {
  return (
    <>
      <div className='flex flex-col lg:flex-row justify-center gap-3'>
        <div className='hidden lg:flex flex-col gap-4 sticky top-6 h-[390px] pt-[20px] '>
          {/* Up Arrow */}
          {thumbnails.length > 4 && (
            <button
              disabled={thumbIndex === 0}
              onClick={() => {
                setThumbIndex(thumbIndex - 1);
                setScrollDirection('up');
                setIsManualSelect(false);
              }}
              className='pl-[1.7rem] disabled:opacity-50'
            >
              <FaAngleUp className='text-2xl text-gray-600' />
            </button>
          )}

          {/* Thumbnails */}
          <div className='flex flex-col gap-4'>
            {thumbnails.slice(thumbIndex, thumbIndex + 4).map((img: any, idx: any) => (
              <img
                key={`thumb-${thumbIndex}-${idx}-${img.image}`}
                src={img.image ? SERVER_URL + img.image : Namsteji_Manikchand_Icon}
                alt={`thumb-${idx}`}
                className={`w-16 h-16 xl:w-[85px] xl:h-[80px] rounded-lg cursor-pointer object-cover border ${
                  mainImage?.image === img.image ? 'border-red-600' : 'border-gray-300'
                }`}
                onMouseEnter={() => {
                  setMainImage(img);
                  setIsManualSelect(true);
                }}
                onClick={() => {
                  setMainImage(img);
                  setIsManualSelect(true);
                }}
              />
            ))}
          </div>

          {/* Down Arrow */}
          {thumbnails.length > 4 && (
            <button
              disabled={thumbIndex + 4 >= thumbnails.length}
              onClick={() => {
                setThumbIndex(thumbIndex + 1);
                setScrollDirection('down');
                setIsManualSelect(false);
              }}
              className='pl-[1.7rem] disabled:opacity-50'
            >
              <FaAngleDown className='text-2xl text-gray-600' />
            </button>
          )}
        </div>

        {/*  Main Image  */}
        <div className='flex justify-center lg:sticky lg:top-6 lg:self-start'>
          <img
            src={mainImage ? SERVER_URL + mainImage.image : Namsteji_Manikchand_Icon}
            alt=''
            // className="w-full  md:w-[450px] lg:w-[500px] lg:h-[500px] rounded-lg"
            className='w-[100%] h-[18rem] sm:w-[100%] sm:h-[18rem] md:w-[450px] md:h-[390px] lg:w-[490px] lg:h-[390px] rounded-lg'
          />
        </div>

        {/*  Thumbnails for SM/MD screens  */}
        <div className='flex lg:hidden flex-row gap-2 justify-center overflow-x-auto'>
          {thumbnails.map((img: any, idx: any) => (
            <img
              key={`thumb-sm-${idx}-${img.image}`}
              src={img.image ? SERVER_URL + img.image : Namsteji_Manikchand_Icon}
              alt=''
              className={`w-16 h-16 rounded-lg cursor-pointer object-cover border ${
                mainImage?.image === img.image ? 'border-red-600' : 'border-gray-300'
              }`}
              onClick={() => {
                setMainImage(img);
                setIsManualSelect(true);
              }}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default ProductThumbnailsComponents;
